module.exports = __webpack_public_path__ + "static/media/18.5233ef0b.mp3";